export enum EMenuKeys {
  EXPEDITION = 'expedition',
  INTEGRATOR = 'integrator',
  FINANCIAL = 'financial',
  TAX = 'tax',
  FINISH = 'finish',
  ACCOUNTANT = 'accountant',
}
